export enum RekisteroityminenEnum {
  Onnistui = 1,
  Epaonnistui,
}
